import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import AppInit from "./components/AppInit";
import "./variables.css";
import "./themes.css";
import { register } from "./serviceWorkerRegistration";
import { syncAppVersion } from "./appVersionSync";

syncAppVersion();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppInit>
        <App />
      </AppInit>
    </AuthProvider>
  </React.StrictMode>
);

register();